import React, { useRef } from "react";
import { css } from "@emotion/react";
import gsap from "gsap";
import { BaseProps } from "./text";
import GText from "./GText";

interface Props {
  text?: string;
  hoverColor?: string;
  duration?: number;
  url?: string;
}

const GTextRotation: React.FC<Props & BaseProps> = (props) => {
  const styles = css`
    display: block;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    padding: 0;

    span {
      white-space: pre;
    }

    &:hover span {
      color: ${props.hoverColor};
    }

    .g_text-wrap {
      position: relative;
      display: flex;
      align-items: center;
    }

    .g_after {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
    }

    .g_before {
      display: flex;
      align-items: center;
    }

    .g_before span,
    .g_after span {
      line-height: 1.1;
      transition: color 0.3s ease-out;
    }

    .g_after span {
      transform: translateY(100%);
    }
  `;

  const splitTextRef = useRef<HTMLAnchorElement>(null);

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, i) => <span key={i}>{l}</span>);
  };

  const handleMouseEnter = () => {
    gsap.to(".g_before span", {
      y: "-105%",
      stagger: 0.04,
      ease: "power2.out",
      duration: props.duration,
    });
    gsap.to(".g_after span", {
      y: "0%",
      stagger: 0.04,
      ease: "power2.out",
      duration: props.duration,
    });
  };

  const handleMouseLeave = () => {
    gsap.to(".g_before span", {
      y: "0%",
      stagger: 0.04,
      ease: "power2.out",
      duration: props.duration,
    });
    gsap.to(".g_after span", {
      y: "100%",
      stagger: 0.04,
      ease: "power2.out",
      duration: props.duration,
    });
  };

  return (
    <GText {...props}>
      <a
        css={styles}
        ref={splitTextRef}
        href={props.url ?? undefined}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <span className="g_text-wrap">
          <div className="g_before">{splitTextIntoSpan()}</div>
          <div className="g_after">{splitTextIntoSpan()}</div>
        </span>
      </a>
    </GText>
  );
};

GTextRotation.defaultProps = {
  text: "Grooody",
  fontSize: 18,
  color: "#000",
  hoverColor: "#854DFF",
  duration: 0.4,
};

export default GTextRotation;

// We need to add the below in framer
/*

addPropertyControls(TextRotation, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 63,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "",
    },
    hoverColor: {
        title: "Hover Color",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    duration: {
        title: "Duration",
        type: ControlType.Number,
        defaultValue: 0.4,
        description: "Animation duration",
    },
})

*/
